/** Shared with LTL-style MUI `Table` blocks (not DataGridPro). */
export const MUI_NATIVE_TABLE_OUTER_SX = {
  width: '100%',
  tableLayout: 'auto',
  '& .MuiTableBody-root .MuiTableRow-root': { borderBottom: 'none' },
  '& .MuiTableCell-root': { borderBottom: 'none' },
};

/** Toolbar row: keep dense switch + icons on one line. */
export const MUI_NATIVE_TABLE_TOOLBAR_ACTIONS_SX = {
  display: 'flex',
  flexWrap: 'nowrap',
  alignItems: 'center',
  gap: 0.5,
  flexShrink: 0,
};

/**
 * @param {boolean} denseMode
 * @param {{ compactHeader?: boolean, bodyRowNonDense?: string }} [options]
 *   compactHeader: pick-progress uses 32px header when not dense
 *   bodyRowNonDense: e.g. '40px' for pick progress (default '48px')
 */
export function getMuiNativeTableDenseLayout(denseMode, options = {}) {
  const { compactHeader = false, bodyRowNonDense = '48px' } = options;
  const headerPx = denseMode ? '30px' : compactHeader ? '32px' : '36px';
  const rowPx = denseMode ? '38px' : bodyRowNonDense;

  return {
    tableSize: denseMode ? 'small' : 'medium',
    headerRowSx: {
      backgroundColor: '#f5f5f5',
      height: headerPx,
      minHeight: headerPx,
      maxHeight: headerPx,
    },
    headerCellSx: {
      fontWeight: 'bold',
      py: denseMode ? 0.25 : 0.5,
      px: denseMode ? 0.75 : 1,
      fontSize: '0.875rem',
      lineHeight: 1,
      height: headerPx,
      minHeight: headerPx,
      maxHeight: headerPx,
    },
    bodyRowSx: {
      height: rowPx,
      minHeight: rowPx,
      maxHeight: rowPx,
      '& td': {
        borderBottom: 'none',
        py: denseMode ? 0.5 : 1,
        px: denseMode ? 0.75 : 1,
        fontSize: '0.8125rem',
        height: rowPx,
        minHeight: rowPx,
        maxHeight: rowPx,
      },
    },
    /** Dialog / nested line tables (LtlDashboard line-level pattern) */
    dialogHeaderRowSx: {
      backgroundColor: '#f5f5f5',
      height: denseMode ? '30px' : '36px',
      minHeight: denseMode ? '30px' : '36px',
      maxHeight: denseMode ? '30px' : '36px',
    },
    dialogHeaderCellSx: {
      fontWeight: 'bold',
      py: denseMode ? 0.25 : 0.75,
      px: denseMode ? 0.75 : 1,
      fontSize: denseMode ? '0.8125rem' : '0.875rem',
      height: denseMode ? '30px' : '36px',
      minHeight: denseMode ? '30px' : '36px',
      maxHeight: denseMode ? '30px' : '36px',
    },
    dialogBodyRowSx: {
      height: rowPx,
      minHeight: rowPx,
      maxHeight: rowPx,
      '& td': {
        py: denseMode ? 0.5 : 1,
        px: denseMode ? 0.75 : 1,
        fontSize: '0.8125rem',
        height: rowPx,
        minHeight: rowPx,
        maxHeight: rowPx,
      },
    },
  };
}
